import { render, staticRenderFns } from "./knowledge-table.vue?vue&type=template&id=5f96dda0&scoped=true"
import script from "./knowledge-table.vue?vue&type=script&lang=js"
export * from "./knowledge-table.vue?vue&type=script&lang=js"
import style0 from "./knowledge-table.vue?vue&type=style&index=0&id=5f96dda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96dda0",
  null
  
)

export default component.exports